import React from "react";

export const getGroupsSteps = () => [
  {
    target: () => document.querySelector('[data-tour-id="portfolios-tab"]'),
    title: "Agrupamento de relatórios",
    description: "Agrupe vários relatórios em uma única visualização com tabs para o cliente final.",
    nextButtonProps: { children: 'Próximo', onClick: () => { const el = document.querySelector('[data-tour-id="portfolios-tab"]'); if (el) el.click(); } }
  },
  {
    target: () => document.querySelector('[data-tour-id="group-stats"]'),
    title: "Visualizações",
    description: "Métricas dos agrupamentos para acompanhar uso e destaque.",
  },
  {
    target: () => document.querySelector('[data-tour-id="create-portfolio-btn"]'),
    title: "Configuração inicial",
    description: "Crie um agrupamento e defina seus parâmetros.",
    nextButtonProps: { children: 'Próximo', onClick: () => window.dispatchEvent(new Event('tour-open-create-portfolio-modal')) }
  },
  {
    target: () => document.querySelector('[data-tour-id="portfolio-form"]'),
    title: "Formulário de agrupamento",
    description: "Selecione projeto, nome e descrição e escolha relatórios.",
    prevButtonProps: { children: 'Anterior', onClick: () => window.dispatchEvent(new Event('tour-close-create-portfolio-modal')) }
  },
  {
    target: () => document.querySelector('[data-tour-id="portfolio-save-btn"]'),
    title: "Salvar e concluir",
    description: "Crie o agrupamento e feche a modal.",
    nextButtonProps: { children: 'Concluir', onClick: () => window.dispatchEvent(new Event('tour-close-create-portfolio-modal')) }
  },
  {
    target: () => document.querySelector('[data-tour-id="share-portfolio-btn"]'),
    title: "Compartilhar agrupamentos",
    description: "Abra a modal de compartilhamento.",
  }
];